import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from "./Navbar";
import Footer from "./Footer.jsx";
import './LegalPages.css';

const RefundPolicy = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="legal-page-container">
        <div className="legal-content">
          <div className="legal-header">
            <h1>No Refund Policy</h1>
            {/* <p>Last Updated: January 1, 2025</p> */}
            <div className="policy-warning">
              <span className="warning-icon">⚠️</span>
              <span>Please read carefully before making any purchase</span>
            </div>
          </div>

          <div className="legal-section">
            <h2>1. General Policy Statement</h2>
            <p>All sales for event tickets, stall bookings, and any other services provided by Royal Heritage Fiesta are <strong>FINAL and NON-REFUNDABLE</strong>. By completing a purchase, you acknowledge and agree to this No Refund Policy.</p>
          </div>

          <div className="legal-section highlight-section">
            <h2>2. No Refunds on Ticket Purchases</h2>
            <p>Event tickets purchased through Royal Heritage Fiesta are non-refundable under any circumstances, including but not limited to:</p>
            <ul>
              <li>Change of personal plans or schedule conflicts</li>
              <li>Inability to attend the event for any reason</li>
              <li>Medical emergencies or family emergencies</li>
              <li>Travel delays or transportation issues</li>
              <li>Weather conditions</li>
              <li>Dislike of event content, artists, or arrangements</li>
            </ul>
          </div>

          <div className="legal-section highlight-section">
            <h2>3. No Refunds on Stall Bookings</h2>
            <p>All stall booking payments are non-refundable. This applies to:</p>
            <ul>
              <li>Full or partial stall bookings</li>
              <li>Cancellation requests for any reason</li>
              <li>Changes in business circumstances</li>
              <li>Low footfall or sales performance concerns</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. Event Cancellation by Organizer</h2>
            <p>In the rare event that Royal Heritage Fiesta cancels an event entirely (not rescheduled):</p>
            <ul>
              <li>Tickets will be valid for the rescheduled date if the event is postponed</li>
              <li>If the event is completely cancelled with no rescheduled date, you may be eligible for a partial or full refund as determined by management</li>
              <li>Processing fees, convenience fees, and other ancillary charges are non-refundable</li>
              <li>We are not responsible for any travel, accommodation, or other expenses incurred</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>5. Event Changes</h2>
            <p>We reserve the right to make changes to event details including:</p>
            <ul>
              <li>Artist lineups and performers</li>
              <li>Event schedules and timings</li>
              <li>Venue locations (within reasonable proximity)</li>
              <li>Food, beverage, or experience offerings</li>
            </ul>
            <p>Such changes do not entitle you to a refund as we strive to provide a comparable or better experience.</p>
          </div>

          <div className="legal-section">
            <h2>6. Ticket Transfer Policy</h2>
            <p>While refunds are not available, you may be permitted to transfer your ticket to another person:</p>
            <ul>
              <li>Transfer requests must be submitted at least 7 days before the event</li>
              <li>A transfer fee may apply</li>
              <li>We do not facilitate ticket resale or exchange between buyers</li>
              <li>Transfers are subject to management approval</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>7. Credit for Future Events</h2>
            <p>In exceptional circumstances and at our sole discretion, we may offer:</p>
            <ul>
              <li>Credit toward a future Royal Heritage Fiesta event instead of a refund</li>
              <li>Such credit is non-transferable and expires within 12 months</li>
              <li>This is a gesture of goodwill and not a right or entitlement</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>8. Disputes and Chargebacks</h2>
            <p>If you dispute a charge or file a chargeback with your bank or payment provider:</p>
            <ul>
              <li>We reserve the right to permanently ban you from future events</li>
              <li>Your tickets will be invalidated</li>
              <li>We may pursue collection of any reversed funds</li>
              <li>Legal action may be taken in appropriate cases</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>9. Booking Confirmation</h2>
            <p>By completing your purchase, you confirm that you have read, understood, and agreed to this No Refund Policy. A confirmation email will be sent to you as a record of your acceptance.</p>
          </div>

          <div className="legal-section">
            <h2>10. Contact Us</h2>
            <p>If you have questions about this policy or need assistance with ticket transfers:</p>
            <ul>
              <li>Email: <a href="mailto:royalheritagefiesta@gmail.com">royalheritagefiesta@gmail.com</a></li>
              <li>Phone: +91 99662 52374</li>
              <li>Please include your booking reference number in all communications</li>
            </ul>
          </div>

          <div className="legal-footer">
            <Link to="/" className="back-home-btn">← Back to Home</Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RefundPolicy;